import React from "react";
import { injectIntl } from "react-intl";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import { Container } from "react-bootstrap";

import Link from "../../components/Link";
import messages from "../../locale/messages";
import bt from '../../components/commonStyle.css';
import s from "./Support.css";

// Web parity with the mobile app's Support screen: shows the contact channels (Email / Phone /
// WhatsApp) from the public site settings, plus a link to the Help/FAQ center. Each channel is
// only rendered when its setting value exists.
const Support = (props) => {
    const { intl: { formatMessage }, contactEmail, contactPhoneNumber, whatsApp } = props;

    // wa.me expects digits only.
    const whatsAppDigits = whatsApp ? String(whatsApp).replace(/[^0-9]/g, '') : '';

    const channels = [
        contactEmail && {
            key: 'email',
            label: formatMessage(messages.emailSupport),
            value: contactEmail,
            href: `mailto:${contactEmail}`,
        },
        contactPhoneNumber && {
            key: 'phone',
            label: formatMessage(messages.callSupport),
            value: contactPhoneNumber,
            href: `tel:${contactPhoneNumber}`,
        },
        whatsAppDigits && {
            key: 'whatsapp',
            label: formatMessage(messages.whatsappSupport),
            value: whatsApp,
            href: `https://wa.me/${whatsAppDigits}`,
            external: true,
        },
    ].filter(Boolean);

    return (
        <div className={cx('subPageContainer')}>
            <Container>
                <div className='subPageWrapper'>
                    <p className={s.pageTitle}>{formatMessage(messages.support)}</p>
                    <p className={s.subText}>{formatMessage(messages.supportIntro)}</p>

                    {channels.length > 0 ? (
                        <ul className={s.channelList}>
                            {channels.map((item) => (
                                <li key={item.key} className={s.channelItem}>
                                    <a
                                        className={s.channelLink}
                                        href={item.href}
                                        {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                                    >
                                        <span className={s.channelInfo}>
                                            <span className={s.channelLabel}>{item.label}</span>
                                            <span className={s.channelValue}>{item.value}</span>
                                        </span>
                                        <span className={s.channelArrow} aria-hidden="true">&rsaquo;</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className={s.emptyText}>{formatMessage(messages.supportNoChannels)}</p>
                    )}

                    <div className={s.faqCard}>
                        <p className={s.faqTitle}>{formatMessage(messages.faqSectionTitle)}</p>
                        <p className={s.faqText}>{formatMessage(messages.faqSectionText)}</p>
                        <Link to="/help" className={cx(bt.btnPrimary, s.faqBtn)}>
                            {formatMessage(messages.viewFaq)}
                        </Link>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default injectIntl(withStyles(bt, s)(Support));
